<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        title="权限管理"
        :visible.sync="dialogVisible"
        append-to-body
        center
        class="dialog-container"
        width="550px">
        <div class="dialog-container flex flex-direction padding-sm">
            <div class="flex flex-wrap">
                <div class="flex align-center margin-right-sm" v-for="(item,index) in org_member_roles" :key="index">
                    <div class="margin-right-xs">{{item.label}}</div>
                    <el-checkbox  v-model="item.rule.permission_checked" @change="checkedChange"></el-checkbox>
                </div>
            </div>
            <el-button :loading="loading" class="btn min self-center margin-top-sm" type="primary" @click="submitItem">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import {toast, TOAST} from "@/utils/utils";
import {getPermissionTypes, menus} from "@/utils/const";
import {setMemberPower} from "@/api";

export default {
    name: "SetMemberPowerDialog",
    components: {},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        index: {
            type: [String, Number],
            default: ''
        },
        pos: {
            type: [String, Number],
            default: ''
        },
        role: {
            type: [String, Number],
            default: ''
        },
        mid: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            org_member_roles: [],
            permission_types:getPermissionTypes(),
            loading: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {

    },
    methods: {
        async init() {

        },
        async submitItem() {
            this.loading = true
            let role = this.org_member_roles.map(item=>{
                return {
                    key:item.rule.key,
                    permission:item.rule.permission_checked ? this.permission_types : []
                }
            });
            let _data = await setMemberPower(this.user.power,this.mid,JSON.stringify(role))
            this.loading = false
            if (_data.status === 200) {
                toast(_data.msg, TOAST.success)
                this.$emit('watchState', {
                    index:this.index,
                    pos:this.pos,
                    role:JSON.stringify(role),
                })
            } else {
                toast(_data.info, TOAST.error)
            }
        },
        cancel() {
            this.$emit('watchState', false)
        },
        checkedChange() {
            this.$forceUpdate()
        }
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                let _permission = this.role ? JSON.parse(this.role) : []
                let filter = menus.filter(f=>{ return f.rule.setting});
                filter.map(item=>{
                    item.rule.permission = this.permission_types
                    item.rule.permission_checked = _permission.find(f => {
                        return f.key === item.rule.key
                    })?.permission?.length > 0
                })
                this.org_member_roles = filter
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {

}
</style>
